import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, roleHome } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { finishGoogle } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const user = await finishGoogle(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(roleHome(user.role), { replace: true });
      } catch (e) {
        setError(true);
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [location.hash, finishGoogle, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6" data-testid="auth-callback">
      <div className="w-16 h-16 rounded-full zenith-cta animate-breathe" />
      <p className="font-headline text-primary text-lg">
        {error ? "Sign-in failed. Redirecting…" : "Signing you in…"}
      </p>
    </div>
  );
}
